import React, { Component, useState } from "react";
import GoogleMapReact from "google-map-react";
import VehicleMarker from "./VehicleMarker";
import Button from "@material-ui/core/Button";
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import { consts } from '../../common/consts'
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            float: 'right',
            top: -100,
            marginRight: 20,
            minWidth: '40px',
            maxWidth: '40px',
            backgroundColor: '#F4B827',
            color: 'black'
        }
    }),
);

const MapsWithMarker = ({ nearestVehicles, center, zoom, height, isNurseView, onZoomButtonClick }: any) => {
    const PRIMARY_COLOR = "#02489D";
    const classes = useStyles();

    return (
        <div style={{ height: height, width: "100%" }}>
            {nearestVehicles.length > 0 &&
                <GoogleMapReact
                    options={isNurseView ? { draggable: false, fullscreenControl: false, zoomControl: false } : { draggable: false }}
                    bootstrapURLKeys={{ key: consts.GooglePlaceAPIKey }}
                    defaultCenter={center}
                    center={center}
                    defaultZoom={zoom}
                    zoom={zoom}>

                    {nearestVehicles.map(({ latitude, longitude, objectNo, color = PRIMARY_COLOR }: any) => {
                        return <VehicleMarker key={objectNo} color={color} lat={latitude / 1000000} lng={longitude / 1000000} vehicleNumber={objectNo} />
                    })}

                </GoogleMapReact>
            }
            {
                isNurseView ?
                    <Button variant="contained" className={classes.button} size="medium" color="secondary" onClick={onZoomButtonClick}>
                        <ZoomOutMapIcon />
                    </Button>
                    :
                    null
            }
        </div>
    );
};

export default MapsWithMarker;